import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ChevronRight } from 'lucide-react';
import { getMarketById } from '@paulownia/shared/services/markets';
import type { Market } from '@paulownia/shared/types';
import { DAY_OF_WEEK_LABELS } from '@paulownia/shared/types';

interface MarketSectionProps {
  marketId: string;
  marketCity: string;
}

export function MarketSection({
  marketId,
  marketCity,
}: MarketSectionProps) {
  const [market, setMarket] = useState<Market | null>(null);

  useEffect(() => {
    getMarketById(marketId).then(setMarket);
  }, [marketId]);

  return (
    <Link
      to={`/market/${marketId}`}
      className="block p-4 hover:bg-gray-50 transition-colors"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center">
            <MapPin className="w-5 h-5 text-orange-600" />
          </div>
          <div>
            <p className="font-semibold text-gray-900">{marketCity}</p>
            {market && (
              <p className="text-sm text-gray-500">
                {DAY_OF_WEEK_LABELS[market.dayOfWeek]} {market.openingTime}-{market.closingTime}
              </p>
            )}
          </div>
        </div>
        <ChevronRight className="w-5 h-5 text-gray-400" />
      </div>
    </Link>
  );
}
